<template>
  <div class="map" :id="id">
  </div>
</template>

<script>
import * as echarts from 'echarts'
import _ from 'lodash'

export default {
  name: 'World',
  props: {
    id: {
      type: [Number, String],
      default: new Date().getTime()
    },
    config: {
      type: [Object, Array],
      default: () => {
        return {}
      }
    },
    chartData: {
      type: Array,
      default () {
        return []
      }
    },
    itemInfo: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      chart: null,
      options: {},
      mubiaoData: [],
      wanchengData: [],
      XData: []
    }
  },
  computed: {

  },
  created () {
    this.$bus.$on('targetColumn', this.checkTypeHandler)
    this.$once('hook:beforeDestory', () => {
      this.$bus.$off('targetColumn')
    })
    this.initChartOptions()
  },
  mounted () {
    let mapDiv = document.getElementById(`${this.id}`)
    this.chart = echarts.init(mapDiv)
    this.chart.setOption(this.options)
  },
  watch: {
    chartData: {
      deep: true,
      immediate: true,
      handler: function (newV, oldV) {
        this.updateOptions()
      }
    },
    config: {
      deep: true,
      immediate: true,
      handler: function (newV, oldV) {
        this.updateOptions()
      }
    },
    itemInfo: {
      deep: true,
      immediate: true,
      handler: function (newV, oldV) {
        this.checkTypeHandler()
      }
    }
  },
  methods: {
    // 重新调整图表大小
    checkTypeHandler (key) {
      if (!this.chart) { return }
      this.chart.resize()
    },
    // 初始化图表选项
    initChartOptions () {
      let _this = this
      this.XData = this.chartData.map(item => item[this.config.mapCol.find(item => item.label === 'X').value])
      this.wanchengData = this.chartData.map(item => item[this.config.mapCol.find(item => item.label === 'Y').value])
      this.mubiaoData = this.chartData.map(item => item[this.config.mapCol.find(item => item.label === 'Z').value])
      var wanchengData1 = (function () {
        var data = []
        for (var i = 0; i < _this.mubiaoData.length; i++) {
          if (_this.mubiaoData[i] && _this.wanchengData[i] > _this.mubiaoData[i]) {
            data.push(_this.mubiaoData[i])
          } else {
            data.push(_this.wanchengData[i])
          }
        }
        return data
      }())
      // 当实际值超出目标值时不再显示目标值
      var chaochuData = (function () {
        var data = []
        for (var i = 0; i < _this.mubiaoData.length; i++) {
          if (_this.wanchengData[i] >= _this.mubiaoData[i]) {
            data.push(_this.wanchengData[i])
            wanchengData1[i] = null
            // _this.mubiaoData[i] = null
          } else {
            data.push('')
          }
        }
        return data
      }())
      this.options = {
        backgroundColor: '#00000000',
        grid: {
          left: 0,
          top: '20%',
          bottom: 60,
          right: 0,
          containLabel: true
        },
        legend: {
          // data: [],
          right: 10,
          textStyle: {
            color: '#fff'
          }
        },
        tooltip: {
          trigger: 'axis',
          padding: [8, 10],
          axisPointer: {
            type: 'shadow',
            textStyle: {
              color: '#fff'
            }
          }
        },
        xAxis: [{
          type: 'category',
          data: _this.XData,
          axisLine: {
            show: true
          },
          axisTick: {
            show: true
          },
          axisLabel: {
            show: this.config.chartStyle.showXtick,
            rotate: this.config.chartStyle.axisLabelRotate,
            textStyle: {
              color: '#fff',
              fontSize: 16,
              fontWeight: 400
            }
          }
        }],
        yAxis: [{
          type: 'value',
          axisLine: {
            show: true
          },
          axisTick: {
            show: true
          },
          axisLabel: {
            show: this.config.chartStyle.showYtick,
            textStyle: {
              color: '#ccc',
              fontSize: 16,
              fontWeight: 400
            }
          }
        }],
        series: [
          {
            name: this.config.legendConfig.achieveText,
            type: 'bar',
            barMaxWidth: 30,
            barGap: '-100%',
            z: 2,
            itemStyle: {
              normal: {
                color: this.config.chartStyle.achieveColor,
                label: {
                  show: true,
                  position: 'top',
                  distance: 0,
                  color: this.config.chartStyle.achieveColor,
                  fontSize: 10,
                  padding: [10, 15, 0, 15],
                  borderRadius: 100
                }
              }
            },
            data: chaochuData
          },
          {
            name: this.config.legendConfig.unachievedText,
            type: 'bar',
            silent: true,
            barMaxWidth: 30,
            barGap: '-100%',
            z: 1,
            itemStyle: {
              normal: {
                color: this.config.chartStyle.unachievedColor,
                label: {
                  show: true,
                  position: 'top',
                  distance: 0,
                  color: this.config.chartStyle.unachievedColor,
                  fontSize: 10,
                  padding: [10, 15, 0, 15],
                  borderRadius: 100
                }
              }
            },
            data: wanchengData1
          }
        ]
      }
      //   根据配置信息配置图表目标线的显示
      if (this.config.chartStyle.showTargetLine) {
        this.addTargetMarkline()
      } else {
        this.addTargetColumn()
      }
    },
    // 添加目标线
    addTargetMarkline () {
      this.options.series.unshift({
        name: this.config.legendConfig.targetText,
        type: 'line',
        barMaxWidth: 30,
        z: 3,
        showSymbol: false,
        itemStyle: {
          normal: {
            color: this.config.chartStyle.targetColor,
            label: {
              show: false,
              textStyle: {
                fontSize: 16
              },
              position: 'top',
              distance: 10
            }
          }
        },
        data: this.mubiaoData
      })
    },
    // 添加目标柱
    addTargetColumn () {
      this.options.series.unshift({
        name: this.config.legendConfig.targetText,
        type: 'bar',
        barMaxWidth: 30,
        z: 0,
        itemStyle: {
          normal: {
            color: this.config.chartStyle.targetColor,
            label: {
              show: false,
              textStyle: {
                fontSize: 16
              },
              position: 'top',
              distance: 10
            }
          }
        },
        data: this.mubiaoData
      })
    },
    updateOptions () {
      if (!this.chart) { return }
      this.chart.clear()
      this.initChartOptions()
      this.chart.setOption(this.options)
    }
  },
  components: {
  }
}
</script>

  <style scoped lang="stylus">
  .map
    width 100%
    height 100%

  </style>
